<template>
  <div>
    <div class="langswitcher">
      <Langswitcher />
    </div>
    <div class="hamburger" v-bind:class="{ open: showMobile }" v-on:click="toggleShowMobile">
      <div class="line"></div>
    </div>
    <div class="mobile-menu" v-bind:class="{ open: showMobile }" v-show="showMobile" v-on:click="toggleShowMobile">
      <ul class="menu-items"></ul>
    </div>
    <div class="desktop-menu">
      <span class="dot"></span>
      <ul class="menu-items">
        <li data-menuanchor="page0" class="active">
          <a href="#page0">
            <span class="label">Intro</span>
          </a>
        </li>
        <li data-menuanchor="page1">
          <a href="#page1">
            <span class="label" v-html="$t('home.banner1.title')"></span>
          </a>
        </li>
        <li data-menuanchor="page2">
          <a href="#page2">
            <span class="label" v-html="$t('home.sec1.title')"></span>
          </a>
        </li>
        <li data-menuanchor="page3">
          <a href="#page3">
            <span class="label" v-html="$t('home.sec2.title')"></span>
          </a>
        </li>
        <li data-menuanchor="page4">
          <a href="#page4">
            <span class="label" v-html="$t('home.sec3.title')"></span>
          </a>
        </li>
        <li data-menuanchor="page5">
          <a href="#page5">
            <span class="label" v-html="$t('home.sec4.title')"></span>
          </a>
        </li>
        <li data-menuanchor="page6">
          <a href="#page6">
            <span class="label" v-html="$t('home.sec6.title')"></span>
          </a>
        </li>
        <li data-menuanchor="page7">
          <a href="#page7">
            <span class="label" v-html="$t('home.sec5.title')">Collaborazioni</span>
          </a>
        </li>
        <li data-menuanchor="page8">
          <a href="#page8">
            <span class="label" v-html="$t('home.contact.title')"></span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Langswitcher from '@/components/Langswitcher.vue';

import { TweenMax } from "gsap";

export default {
  name: "Menu",
  components: {
    Langswitcher
  },
  props: {
    bus: {}
  },
  data() {
    return {
      showMobile: false
    };
  },
  mounted() {
    let container = this.$el.querySelector(".mobile-menu > .menu-items");
    for (let item of this.$el.querySelectorAll(
      ".desktop-menu > .menu-items li"
    )) {
      let clone = item.cloneNode(true);
      container.appendChild(clone);
    }

    this.bus.$on("pagechanging", (data, destination) => {
      this.positionDot(destination.index);
    });
    window.onresize = () => {
      let parent = this.$el.querySelector('.menu-items')
      let el = parent.querySelector('.active')
      let idx = Array.prototype.indexOf.call(parent.children, el);
      this.positionDot(idx)
    }
  },
  methods: {
    toggleShowMobile(e) {
      console.log('clicked')
      this.showMobile = !this.showMobile;
    },
    positionDot(idx) {
      let menu = this.$el.querySelector(".desktop-menu"),
        dot = menu.querySelector(".dot"),
        active = menu.querySelectorAll("li")[idx].querySelector("a"),
        p = navigator.userAgent.toLowerCase().indexOf('ipad') > -1 ? 4 : 2,
        y =
          active.getBoundingClientRect().y -
          menu.getBoundingClientRect().y -
          dot.getBoundingClientRect().height / 2 + p;
      TweenMax.set(dot, { y: y });

      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.langswitcher {
  position: absolute;
  top: 18px;
  left: calc(100% - 140px);
  z-index: 22;
  @include media-breakpoint-up(xl) {
    left: calc(100% - 60px);
  }

  /deep/ select {
    background: transparent;
    color: white;
    border: none;
    outline: none;
    appearance: none;
    cursor: pointer;
    text-align: left;
  }
}
.hamburger {
  position: fixed;
  z-index: 22;
  top: 20px;
  right: 30px;
  display: block;
  height: 20px;
  width: 30px;
  cursor: pointer;
  overflow: hidden;
  .line {
    background: white;
    position: relative;
    top: 8.5px;
    width: 100%;
    height: 2px;
    transition: transform 0.2s ease-in;
  }
  &:after,
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background: white;
    transition: transform 0.2s ease-in 0.1s;
    transform-origin: 0 0;
  }
  &:after {
    top: 18px;
  }
  &.open {
    .line,
    &:before,
    &:after {
      background: white;
    }
    &:before {
      transform: rotate(37deg);
    }
    &:after {
      transform: rotate(-37deg);
    }
    .line {
      transform: translateX(100%);
    }
  }
}
.fp-viewing-page1 ,
.fp-viewing-page6  {
  .langswitcher /deep/ select {
    color: black;
  }
  .hamburger:not(.open) {
    &:before,
    &:after,
    .line {
      background: black;
    }
  }
}

.mobile-menu {
  position: fixed;
  z-index: 21;
  width: 100%;
  height: 100%;
  background: black;
  color: white;

  a {
    color: white;
  }
  .menu-items {
    margin-top: 100px;
    margin-left: 5vw;
    li {
      list-style: none;
      margin-bottom: 5px;
      font-family: $headings-font-family;
      font-size: 1.5rem;
    }
    > li > a {
      cursor: pointer;
      position: relative;
      &:after {
        display: inline-block;
        position: absolute;
        left: 100%;
        top: -0.45em;
        content: '.';
        color: $red;
        margin-left: 2px;
        font-size: 1.5em;
      }
    }
  }
}
        

.hamburger,
.mobile-menu {
  display: block;
  @include media-breakpoint-up(xl) {
    display: none;
  }
}

.desktop-menu {
  @include media-breakpoint-down(md) {
    display: none;
  }
  position: fixed;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  z-index: 11;
  font-size: 14px;
  font-family: $headings-font-family;
  text-align: right;
  @include media-breakpoint-down(lg) {
    .label {
      display: none;
    }
  }

  li {
    list-style: none;
    margin-top: 15px;
    margin-bottom: 15px;
    position: relative;
    &:after {
      content: "";
      display: inline-block;
      margin-left: 5px;
      margin-top: 5px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      border: 1px solid $light-gray;
      transition: transform 0.4s ease-out;
    }
    &:not(.active):after {
      transform: scale(0.7) translateY(30%);
    }
    &:before {
      content: "";
      height: 23px;
      width: 5px;
      right: 4px;
      position: absolute;
      top: 85%;
      background: transparent url("~@/assets/img/dot.svg") repeat-y center
        center;
    }
    &:last-child:before {
      display: none;
    }
    @media (min-height: 1000px) {
      margin-bottom: 30px;
      &:before {
        height: 38px;
        top: 95%;
      }
    }
  }
  a {
    color: $light-gray;
    &:hover {
      text-decoration: none;
    }
    @at-root {
      .fp-viewing-page6 & {
        color: black;
      }
    }
    @at-root .fp-viewing-page1 & {
      color: black;
    }

  }
  .active a {
    color: white;
    @at-root {
      .fp-viewing-page6 & {
        color: black;
      }
    }
    @at-root .fp-viewing-page1 & {
      color: black;
    }
  }

  .dot {
    content: "";
    position: absolute;
    background: red;
    z-index: 12;
    width: 8px;
    height: 8px;
    display: block;
    border-radius: 50%;
    right: 2px;
    top: 7px;
    transform: translateY(15px);
    transition: transform 0.8s cubic-bezier(0, 0, 0.35, 0.99);
  }
}
</style>
